var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgBulletPointIcon = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 16,
  height: 17,
  viewBox: "0 0 16 17",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M8 0.286621C3.584 0.286621 0 3.87062 0 8.28662C0 12.7026 3.584 16.2866 8 16.2866C12.416 16.2866 16 12.7026 16 8.28662C16 3.87062 12.416 0.286621 8 0.286621ZM8 14.6866C4.472 14.6866 1.6 11.8146 1.6 8.28662C1.6 4.75862 4.472 1.88662 8 1.88662C11.528 1.88662 14.4 4.75862 14.4 8.28662C14.4 11.8146 11.528 14.6866 8 14.6866Z",
  fill: "#31417A",
  fillOpacity: 0.7
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M8.93949 7.53662H2V9.03662H8.93949V11.2866L12 8.28662L8.93949 5.28662V7.53662Z",
  fill: "#B7BDD1"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgBulletPointIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/bulletPointIcon.29615f31a2668ad3ce94dd300a0ac886.svg";